import React from 'react';
import { Button } from 'components';
import { inviteUserToKreditdata } from 'api/neway';
import Alert from '@material-ui/lab/Alert';
import getConfig from 'next/config';

const ComponentsKreditdataRedirectButton = ({ children,flow, existingCustomerId, ...rest }) => {
    const { publicRuntimeConfig:{ uniify } } = getConfig();

    const handleClick = async () => {
        const customerId = existingCustomerId || await inviteUserToKreditdata({ flow });
        const templateIdKey = `${flow}TemplateId`;
        if (customerId) {
            const kreditDataUrl = `https://app.kreditdata.dk/consent/${uniify.teamId}/${uniify[templateIdKey]}?cc=${customerId}`;
            window.location.assign(kreditDataUrl);
        } else {
            Alert('Der er noget galt, prøv igen senere');
        }
    };
    return (
        <Button
            { ...rest }
            style={{ minHeight: '42px', ...rest.style }}
            onClick={ async () => {
                await handleClick();
            } }
        >
            { children }
        </Button>
    );
};

ComponentsKreditdataRedirectButton.defaultProps = {};

ComponentsKreditdataRedirectButton.propTypes = {};

export default ComponentsKreditdataRedirectButton;
